module.exports = __webpack_public_path__ + "static/media/filter-music.af94ee20.svg";